export default "__VITE_ASSET__CqJHbuWh__"